import React from "react";
import ShoppingCartCheckoutIcon from "@mui/icons-material/ShoppingCartCheckout";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import {
  Divider,
  Snackbar,
  Box,
  Typography,
  Button,
  Alert,
} from "@mui/material";
import { zhTW } from "date-fns/locale";
import { format } from "date-fns";
import { useTheme } from "@mui/material/styles";
import { useState, useEffect } from "react";
function CheckoutDrawer({
  storeName,
  table,
  total,
  startTime,
  endTime,
  priceIndex,
  nextStep,

  onlinePaymentAvailable = false,
  invoiceEnable = false,
  invoiceLoveCodes = [],
  invoiceLoveCodeNames = {},
}) {
  const [snakeOpen, setSnakeOpen] = useState(false);
  const [snakeMsg, setSnakeMsg] = useState("");
  const theme = useTheme();

  useEffect(() => {
    // if (differenceInHours < 2 && endTime !== null) {
    //   setSnakeMsg("預定需大於兩小時。");
    //   setSnakeOpen(true);
    //   return;
    // }
    // if (isBonusOverlay) {
    //   setSnakeMsg("贈送的時間已被預訂或超出可預定範圍。");
    //   setSnakeOpen(true);
    //   return;
    // }

    setSnakeMsg(""); // Clear message if the condition is no longer met
    setSnakeOpen(false);
  }, [endTime]);

  const differenceInHours =
    (new Date(endTime) - new Date(startTime)) / (1000 * 60 * 60);
  const handleCheckoutClicked = () => {
    nextStep({
      order: {
        storeName: storeName,
        tableName: table ? table.Name : null,
        tableCode: table ? table.Code : null,
        startTime: startTime,
        endTime: endTime,
        priceIndex: priceIndex,
        total: total,
        invoiceEnable: invoiceEnable,
        invoiceLoveCodes: invoiceLoveCodes,
        invoiceLoveCodeNames: invoiceLoveCodeNames,
      },
    });
  };

  // Helper function to map day of the week to Chinese character
  const getDayInChinese = (date) => {
    const days = ["日", "一", "二", "三", "四", "五", "六"];
    const day = date.getDay();
    return days[day];
  };

  // Format function
  const formatDateToCustomString = (date) => {
    if (!(date instanceof Date)) {
      return "未選擇";
    }

    const monthDay = format(date, "MM/dd", { locale: zhTW });
    const chineseDay = getDayInChinese(date);
    const time = format(date, "HH:mm", { locale: zhTW });

    return `${monthDay}(${chineseDay}) ${time}`;
  };
  return (
    <>
      <Box
        borderTop={1}
        borderColor={"#ababab"}
        borderRadius={2}
        sx={{
          position: "fixed",
          bottom: 0,
          left: 0,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between", // Changed to space-between
          bgcolor: theme.palette.primary.main,
          width: "100%",
          height: "80px",
          zIndex: 1,
        }}
      >
        <Box
          marginLeft={1}
          minWidth={"60px"}
          display="flex"
          alignItems="center"
          flexDirection="column"
          justifyContent="center"
        >
          <Typography
            align="center"
            style={{
              color: theme.palette.text.primary,
              fontWeight: "bold",
              fontSize: "14pt",
            }}
          >
            {storeName}
          </Typography>
          <Typography
            align="center"
            style={{
              color: theme.palette.text.primary,
              fontWeight: "bold",
            }}
          >
            {table ? table.Name : null}
          </Typography>
        </Box>
        <Divider orientation="vertical"></Divider>
        <Box
          width="35%"
          display="flex"
          flexDirection="column"
          alignItems="flex-start"
          marginLeft={1}
        >
          <Box width="max-content">
            <Typography
              align="center"
              style={{
                color: theme.palette.text.primary,
                fontWeight: "bold",
              }}
            >
              {formatDateToCustomString(startTime)}
            </Typography>

            <Box display="flex" justifyContent="center" width="100%">
              <ArrowDownwardIcon fontSize="small" />
            </Box>

            <Typography
              align="center"
              style={{
                color: theme.palette.text.primary,
                fontWeight: "bold",
              }}
            >
              {formatDateToCustomString(endTime)}
            </Typography>
          </Box>
        </Box>
        <Box width="30%">
          <Typography
            align="left"
            style={{
              color: theme.palette.text.primary,
              fontWeight: "bold",
              fontSize: "12pt",
            }}
          >
            總計${total}
          </Typography>
          <Button
            
            onClick={handleCheckoutClicked}
            disabled={
              endTime === null || startTime === null || !onlinePaymentAvailable
            }
            
            sx={{
              fontSize: "14pt",
              minWidth:'90%',
              background: theme.gradients.primary,
              color: theme.palette.text.selected,
              border: theme.gradients.primary,
              borderRadius: "10px",
              "&.Mui-disabled": {
                background: theme.palette.action.disabledBackground,
                color: theme.palette.action.disabled, // Customize this color as needed
              },
              
            }}
          >
            {onlinePaymentAvailable ? "結帳" : "無"}
          </Button>
        </Box>
      </Box>
      <Snackbar
        sx={{ marginBottom: "11vh" }}
        open={snakeOpen}
        autoHideDuration={2500}
        onClose={(event, reason) => {
          if (reason === "clickaway") {
            setSnakeOpen(false);
          }
        }}
        message={snakeMsg}
      >
        <Alert
          onClose={(event, reason) => {
            if (reason === "clickaway") {
              setSnakeOpen(false);
            }
          }}
          severity="warning"
          sx={{ width: "60%" }}
        >
          {snakeMsg}
        </Alert>
      </Snackbar>
    </>
  );
}

export default CheckoutDrawer;
